module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-detail"
  }, [_c('div', [_c('a', {
    staticClass: "hide",
    attrs: {
      "id": "print_download_link"
    }
  }), _c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message_i18n' in _vm.notify),
      expression: "'message_i18n' in notify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message_i18n)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message' in _vm.notify),
      expression: "'message' in notify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message)))])])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.reportSendNotify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.reportSendNotify.success, 'alert-danger': _vm.reportSendNotify.danger, 'alert-warning': _vm.reportSendNotify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message_i18n' in _vm.reportSendNotify),
      expression: "'message_i18n' in reportSendNotify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.reportSendNotify.message_i18n)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('message' in _vm.reportSendNotify),
      expression: "'message' in reportSendNotify"
    }],
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.reportSendNotify.message)))])])])]) : _vm._e()])], 1), _c('div', [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), (_vm.isReportSend) ? [_c('li', [_c('a', {
    on: {
      "click": _vm.goReportHistoryList
    }
  }, [(_vm.$route.params.type === 'facility') ? [_vm._v(_vm._s(_vm.$t('Select Facility')))] : _vm._e(), (_vm.$route.params.type === 'facility_person') ? [_vm._v(_vm._s(_vm.$t('Select Facility Person')))] : _vm._e(), (_vm.$route.params.type === 'clinic') ? [_vm._v(_vm._s(_vm.$t('Select Clinic')))] : _vm._e(), (_vm.$route.params.type === 'care_office') ? [_vm._v(_vm._s(_vm.$t('Select Care Office')))] : _vm._e()], 2)]), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goPrev(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Report History')))])])] : [_c('li', [_c('a', {
    on: {
      "click": _vm.goPatientsList
    }
  }, [_vm._v(_vm._s(_vm.$t('Outpatient.Search Patients')))])]), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goPrev(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Report Show')))])])], _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Report Detail')))])])], 2)]), (_vm.loading || !_vm.searchCallbackFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), (!_vm.loading && _vm.report !== null && _vm.reportExists) ? _c('div', [(_vm.report.del_flag === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('report.report_delete')))])])])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.report.del_flag !== 1) ? [(_vm.isAdminOrPharmacist) ? [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.onClickReSend('doctor')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.send_clinic')))])]), (!_vm.utils.isBlank(_vm.report.careman_id)) ? [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.onClickReSend('careman')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.re_send_careman')))])])] : _vm._e()] : _vm._e(), _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.onClickPdf(1, 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.clinic_pdf')))])]), _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.onClickPdf(0, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.careman_pdf')))])]), _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.onClickPdf('', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.yakureki_pdf')))])]), _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.onClickPdf(1, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.renmei_pdf')))])]), (_vm.isAdminOrPharmacist) ? [(_vm.isReportSendCancelable) ? [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#cancel_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.cancelable')))])])] : _vm._e(), (_vm.isReportSendReStartable) ? [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.onClickShowModalRestartSend()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.re_startable')))])])] : _vm._e()] : _vm._e()] : _vm._e()], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.report.report_type_name))])]), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "label",
    class: {
      'label-danger': _vm.report.post_status == 'temp', 'label-primary': _vm.report.post_status == 'post', 'label-default': _vm.report.post_status == 'no_post'
    }
  }, [_vm._v(_vm._s(_vm.report.post_status_name))])])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-report margin-top"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "col-xs-1"
  }, [_vm._v(_vm._s(_vm.$t('report.patient_name')))]), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.patient.patient_name))]), _c('th', {
    staticClass: "col-xs-1"
  }, [_vm._v(_vm._s(_vm.$t('report.birthday')))]), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.patient.birthday))]), _c('th', {
    staticClass: "col-xs-1"
  }, [_vm._v(_vm._s(_vm.$t('Clinic Name')))]), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.report.clinic_name))]), _c('th', {
    staticClass: "col-xs-1"
  }, [_vm._v(_vm._s(_vm.$t('Doctor Name')))]), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.report.doctor_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.shohoubi')))]), _c('td', [_vm._v(_vm._s(_vm.report.prescribe_date))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.chouzaibi')))]), _c('td', [_vm._v(_vm._s(_vm.report.make_date))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.houmonbi')))]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.report.delivery_date))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.haiyaku_naiyou')))]), _c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.shohou_nichi')))])]), _c('td', [_vm._v(_vm._s(_vm.report.taking_period) + _vm._s(_vm.$t('report.nichi')))]), _c('th', [_c('span', [_vm._v(_vm._s(_vm.$t('report.fukuyoukikan')))])]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.report.taking_start_date) + " " + _vm._s(_vm.report.taking_start_method_name) + "\n " + _vm._s(_vm.$t('report.divide')) + " \n" + _vm._s(_vm.report.taking_end_date) + " " + _vm._s(_vm.report.taking_end_method_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.konkai_haitatsu')))]), _c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.nichisu')))])]), _c('td', [_vm._v(_vm._s(_vm.report.deli_period) + " " + _vm._s(_vm.$t('report.nichi')))]), _c('th', [_c('span', [_vm._v(_vm._s(_vm.$t('report.fukuyoukikan')))])]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.report.deli_start_date) + " " + _vm._s(_vm.report.deli_start_method_name) + "\n " + _vm._s(_vm.$t('report.divide')) + " \n" + _vm._s(_vm.report.deli_end_date) + " " + _vm._s(_vm.report.deli_end_method_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.henkouten')))]), _c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.report.prescribe_change))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.shidou_naiyou')))]), _c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_c('pre', {
    staticClass: "normal"
  }, [_vm._v(_vm._s(_vm.report.soap_comment))])])]), (_vm.nsUsage && _vm.nsUsage.length > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "rowspan": "13"
    }
  }, _vm._l((_vm.nsUsage), function(usage) {
    return _c('div', [_vm._l((usage['relationships']['ns-medicines']), function(medicine) {
      return [_vm._l((medicine['data']), function(drug) {
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [(drug['relationships']['medicine']['data'] == null) ? [_c('span', [_vm._v(_vm._s(drug['attributes']['drug-name']))])] : [_c('a', {
          on: {
            "click": function($event) {
              _vm.goMedicinesDetail(drug['relationships']['medicine']['data']['data']['id'])
            }
          }
        }, [_vm._v(_vm._s(drug['attributes']['drug-name']))])], (drug['attributes']['dose'] != 0) ? [_c('span', {
          staticStyle: {
            "padding-left": "15px"
          }
        }, [_vm._v(_vm._s(drug['attributes']['dose']) + _vm._s(drug['attributes']['dosage-unit']))])] : _vm._e()], 2)])]
      }), _c('div', {
        staticClass: "row",
        staticStyle: {
          "margin-bottom": "20px"
        }
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_vm._v(_vm._s(usage['attributes']['usage-name-1']) + " " + _vm._s(usage['attributes']['usage-name-2']) + " " + _vm._s(usage['attributes']['usage-name-3'])), (usage['attributes']['number-of-days'] != 0) ? _c('span', {
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v(_vm._s(usage['attributes']['number-of-days']) + " " + _vm._s("日分"))]) : _vm._e()])])]
    })], 2)
  })), _c('th', {
    attrs: {
      "rowspan": "13"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.kakunin_jikou')))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.taking_status')))]), _c('td', [_vm._v(_vm._s(_vm.report.taking_status_name))]), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "13"
    }
  }, [_c('pre', {
    staticClass: "normal"
  }, [_vm._v(_vm._s(_vm.report.confirm_comment))])])]) : _c('tr', [_c('th', {
    attrs: {
      "rowspan": "13"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.kakunin_jikou')))]), _c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.taking_status')))]), _c('td', [_vm._v(_vm._s(_vm.report.taking_status_name))]), _c('td', {
    attrs: {
      "colspan": "5",
      "rowspan": "13"
    }
  }, [_c('pre', {
    staticClass: "normal"
  }, [_vm._v(_vm._s(_vm.report.confirm_comment))])])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.remnant_status')))]), _c('td', [_vm._v(_vm._s(_vm.report.remnant_status_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.condition_change')))]), _c('td', [_vm._v(_vm._s(_vm.report.condition_change_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.side_effect_status')))]), _c('td', [_vm._v(_vm._s(_vm.report.side_effect_status_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.interaction')))]), _c('td', [_vm._v(_vm._s(_vm.report.interaction_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.take_interaction')))]), _c('td', [_vm._v(_vm._s(_vm.report.take_interaction_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.complication')))]), _c('td', [_vm._v(_vm._s(_vm.report.complication_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.other_dosage')))]), _c('td', [_vm._v(_vm._s(_vm.report.other_dosage_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.otc_combination')))]), _c('td', [_vm._v(_vm._s(_vm.report.otc_combination_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.visit_duty')))]), _c('td', [_vm._v(_vm._s(_vm.report.visit_duty_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.dispense_idea')))]), _c('td', [_vm._v(_vm._s(_vm.report.dispense_idea_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.last_request')))]), _c('td', [_vm._v(_vm._s(_vm.report.last_request_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.ari_nashi_name.medicine_notebook')))]), _c('td', [_vm._v(_vm._s(_vm.report.medicine_notebook_name))])])])])]), _c('p', [_vm._v(_vm._s(_vm.$t('report.ijyou1'))), _vm._v(_vm._s(_vm.$t('Double Space'))), _vm._v(_vm._s(_vm.$t('Double Space'))), _vm._v(_vm._s(_vm.report.reportor_shop.shop_name)), _vm._v(" " + _vm._s(_vm.$t('Double Dot')) + " "), _vm._v(_vm._s(_vm.$t('report.ijyou2'))), _vm._v(_vm._s(_vm.$t('Double Space'))), _vm._v(_vm._s(_vm.report.user_name))]), _c('br'), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinic(_vm.report) || _vm.isReportTypeCareoffice(_vm.report)),
      expression: "isReportTypeClinic(report) || isReportTypeCareoffice(report)"
    }]
  }, [_vm._v("送信先宛先情報")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-report"
  }, [_c('tbody', [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSendCheck(_vm.report)),
      expression: "isReportTypeClinicSendCheck(report)"
    }]
  }, [(_vm.report.clinic_send_type_fax && _vm.report.clinic_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), (_vm.report.clinic_send_type_fax && !_vm.report.clinic_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), (!_vm.report.clinic_send_type_fax && _vm.report.clinic_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), (!_vm.report.clinic_send_type_fax && !_vm.report.clinic_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), _c('th', {
    staticClass: "col-sm-2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('td', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_type_post),
      expression: "report.clinic_send_type_post"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_type_fax),
      expression: "report.clinic_send_type_fax"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_type_email),
      expression: "report.clinic_send_type_email"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.clinic_send_timing),
        expression: "parseInt(list.id, 10) === report.clinic_send_timing"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.clinic_send_timing_hour),
        expression: "parseInt(list.id, 10) === report.clinic_send_timing_hour"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2)], 2), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSendCheck(_vm.report) && _vm.report.clinic_send_type_fax),
      expression: "isReportTypeClinicSendCheck(report) && report.clinic_send_type_fax"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.clinic_fax))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSendCheck(_vm.report) && _vm.report.clinic_send_type_email),
      expression: "isReportTypeClinicSendCheck(report) && report.clinic_send_type_email"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.clinic_email))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSendCheck(_vm.report)),
      expression: "isReportTypeClinicSendCheck(report)"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('td', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_fusezi_flag === 1),
      expression: "report.clinic_fusezi_flag === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_fusezi_flag === 1),
      expression: "report.clinic_fusezi_flag === 1"
    }]
  }, [_vm._v("  " + _vm._s(_vm.$t('report.fusezi_msg1')) + " " + _vm._s(_vm.$t('report.fusezi_msg2')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_fusezi_flag !== 1),
      expression: "report.clinic_fusezi_flag !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSend(_vm.report)),
      expression: "isReportTypeClinicSend(report)"
    }]
  }, [(_vm.report.clinic_send_info.send_type_fax && _vm.report.clinic_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), (_vm.report.clinic_send_info.send_type_fax && !_vm.report.clinic_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), (!_vm.report.clinic_send_info.send_type_fax && _vm.report.clinic_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), (!_vm.report.clinic_send_info.send_type_fax && !_vm.report.clinic_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])] : _vm._e(), _c('th', {
    staticClass: "col-sm-2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('td', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_info.send_type_post),
      expression: "report.clinic_send_info.send_type_post"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_info.send_type_fax),
      expression: "report.clinic_send_info.send_type_fax"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_info.send_type_email),
      expression: "report.clinic_send_info.send_type_email"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.clinic_send_info.send_timing),
        expression: "parseInt(list.id, 10) === report.clinic_send_info.send_timing"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.clinic_send_info.send_timing_hour),
        expression: "parseInt(list.id, 10) === report.clinic_send_info.send_timing_hour"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2)], 2), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSend(_vm.report) && _vm.report.clinic_send_info.send_type_fax),
      expression: "isReportTypeClinicSend(report) && report.clinic_send_info.send_type_fax"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.clinic_send_info.fax))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSend(_vm.report) && _vm.report.clinic_send_info.send_type_email),
      expression: "isReportTypeClinicSend(report) && report.clinic_send_info.send_type_email"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.clinic_send_info.email))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeClinicSend(_vm.report)),
      expression: "isReportTypeClinicSend(report)"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('td', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_info.fusezi_flag === 1),
      expression: "report.clinic_send_info.fusezi_flag === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_info.fusezi_flag === 1),
      expression: "report.clinic_send_info.fusezi_flag === 1"
    }]
  }, [_vm._v("  " + _vm._s(_vm.$t('report.fusezi_msg1')) + " " + _vm._s(_vm.$t('report.fusezi_msg2')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.clinic_send_info.fusezi_flag !== 1),
      expression: "report.clinic_send_info.fusezi_flag !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])]), (!_vm.utils.isBlank(_vm.report.careman_id)) ? [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSendCheck(_vm.report)),
      expression: "isReportTypeCareofficeSendCheck(report)"
    }]
  }, [(_vm.report.careoffice_send_type_fax && _vm.report.careoffice_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), (_vm.report.careoffice_send_type_fax && !_vm.report.careoffice_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), (!_vm.report.careoffice_send_type_fax && _vm.report.careoffice_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), (!_vm.report.careoffice_send_type_fax && !_vm.report.careoffice_send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), _c('th', {
    staticClass: "col-sm-2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('td', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_type_post),
      expression: "report.careoffice_send_type_post"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_type_fax),
      expression: "report.careoffice_send_type_fax"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_type_email),
      expression: "report.careoffice_send_type_email"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.careoffice_send_timing),
        expression: "parseInt(list.id, 10) === report.careoffice_send_timing"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.careoffice_send_timing_hour),
        expression: "parseInt(list.id, 10) === report.careoffice_send_timing_hour"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2)], 2), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSendCheck(_vm.report) && _vm.report.careoffice_send_type_fax),
      expression: "isReportTypeCareofficeSendCheck(report) && report.careoffice_send_type_fax"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.careoffice_fax))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSendCheck(_vm.report) && _vm.report.careoffice_send_type_email),
      expression: "isReportTypeCareofficeSendCheck(report) && report.careoffice_send_type_email"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.careoffice_email))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSendCheck(_vm.report)),
      expression: "isReportTypeCareofficeSendCheck(report)"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('td', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_fusezi_flag === 1),
      expression: "report.careoffice_fusezi_flag === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_fusezi_flag === 1),
      expression: "report.careoffice_fusezi_flag === 1"
    }]
  }, [_vm._v("  " + _vm._s(_vm.$t('report.fusezi_msg1')) + " " + _vm._s(_vm.$t('report.fusezi_msg2')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_fusezi_flag !== 1),
      expression: "report.careoffice_fusezi_flag !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSend(_vm.report)),
      expression: "isReportTypeCareofficeSend(report)"
    }]
  }, [(_vm.report.careoffice_send_info.send_type_fax && _vm.report.careoffice_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), (_vm.report.careoffice_send_info.send_type_fax && !_vm.report.careoffice_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), (!_vm.report.careoffice_send_info.send_type_fax && _vm.report.careoffice_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), (!_vm.report.careoffice_send_info.send_type_fax && !_vm.report.careoffice_send_info.send_type_email) ? [_c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])] : _vm._e(), _c('th', {
    staticClass: "col-sm-2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.send_type')))])]), _c('td', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_info.send_type_post),
      expression: "report.careoffice_send_info.send_type_post"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.post')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_info.send_type_fax),
      expression: "report.careoffice_send_info.send_type_fax"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fax')) + "  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_info.send_type_email),
      expression: "report.careoffice_send_info.send_type_email"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.email')))]), _vm._l((_vm.getNameList('report.send_timing')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.careoffice_send_info.send_timing),
        expression: "parseInt(list.id, 10) === report.careoffice_send_info.send_timing"
      }]
    }, [_vm._v(_vm._s(list.text) + "  ")])
  }), _vm._l((_vm.getNameList('report.send_timing_hour')), function(list) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(list.id, 10) === _vm.report.careoffice_send_info.send_timing_hour),
        expression: "parseInt(list.id, 10) === report.careoffice_send_info.send_timing_hour"
      }]
    }, [_vm._v(_vm._s(list.text))])
  })], 2)], 2), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSend(_vm.report) && _vm.report.careoffice_send_info.send_type_fax),
      expression: "isReportTypeCareofficeSend(report) && report.careoffice_send_info.send_type_fax"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fax')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.careoffice_send_info.fax))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSend(_vm.report) && _vm.report.careoffice_send_info.send_type_email),
      expression: "isReportTypeCareofficeSend(report) && report.careoffice_send_info.send_type_email"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.email')))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.report.careoffice_send_info.email))])])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReportTypeCareofficeSend(_vm.report)),
      expression: "isReportTypeCareofficeSend(report)"
    }]
  }, [_c('th', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi')))])]), _c('td', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_info.fusezi_flag === 1),
      expression: "report.careoffice_send_info.fusezi_flag === 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_ari')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_info.fusezi_flag === 1),
      expression: "report.careoffice_send_info.fusezi_flag === 1"
    }]
  }, [_vm._v("  " + _vm._s(_vm.$t('report.fusezi_msg1')) + " " + _vm._s(_vm.$t('report.fusezi_msg2')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.careoffice_send_info.fusezi_flag !== 1),
      expression: "report.careoffice_send_info.fusezi_flag !== 1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('report.fusezi_nashi')))])])])] : _vm._e()], 2)])]), _c('table', {
    staticClass: "table table-bordered table-report margin-top"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('report.create_time')))]), _c('td', {
    staticClass: "col-sm-10",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.report.report_create_time))])]), _c('tr', [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('report.update_time')))]), _c('td', {
    staticClass: "col-sm-10",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.report.report_update_time))])])])])]) : _vm._e(), (_vm.loading) ? [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goPrev(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])])] : _vm._e(), (_vm.report !== null && _vm.reportExists) ? [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-4 text-left"
  }, [(_vm.report.del_flag !== 1) ? [(_vm.isAdminOrPharmacistManager) ? [_c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delete_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Delete')))])])] : _vm._e(), (_vm.isAdminOrPharmacist) ? [(_vm.isReportSendCancelable) ? [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#cancel_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.cancelable')))])])] : _vm._e(), (_vm.isReportSendReStartable) ? [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.onClickShowModalRestartSend()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('report.re_startable')))])])] : _vm._e()] : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "col-xs-8 text-right"
  }, [(_vm.report.del_flag !== 1) ? [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.onClickReportEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Edit')))])])] : _vm._e(), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goPrev(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])], 2)])] : _vm._e(), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete_confirm_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.delete_confirm')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.delete_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickDeleteReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "restart_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#restart_confirm_modal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "restart_confirm_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.restart')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group form-inline"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('report.modal.restart_msg1')))]), _c('date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.restartDate),
      expression: "restartDate",
      modifiers: {
        "lazy": true
      }
    }],
    class: {
      required: _vm.requiredRestart.restartDate || _vm.requiredRestart.restartDate_format
    },
    staticStyle: {
      "width": "160px"
    },
    domProps: {
      "value": (_vm.restartDate)
    },
    on: {
      "change": function($event) {
        _vm.restartDate = $event
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restartTime),
      expression: "restartTime"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bulk_date_type"
    },
    on: {
      "change": function($event) {
        _vm.restartTime = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((24), function(n) {
    return _c('option', {
      domProps: {
        "value": (n - 1) + ':00'
      }
    }, [_vm._v(_vm._s((n - 1)) + ":00")])
  })), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('report.modal.restart_msg2')))])], 1)])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isRestartComplete) ? [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickRestartSend()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Confirm')))])] : [_c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('Confirm')))])], _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])], 2)])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "cancel_confirm_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('report.modal.cancel')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('report.modal.cancel_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickCancelSend()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "help-modal",
      "role": "dialog",
      "aria-labelledby": "helpModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(4), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "helpModal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Help Modal.Modal Title.Report History')))])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal-body-cell"
  }, [_c('table', [_c('tbody', [_c('tr', [_vm._m(5), _c('td', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Help Modal.Discription.Send Stop')))])])])])])])])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "help-image"
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": require("../../../static/help-image/send_stop.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97497aee!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/report-detail.pug
// module id = 406
// module chunks = 1